export const PAGINATION_SIZE_LIST = [100, 300, 500, 1000];
